class BaseCellRender {
  /**
   * @var {string}
   */
  type;

  /**
   * @var {Function.<TableColumn, Object>}
   */
  getRowData;

  constructor(type, getRowData) {
    this.type = type;
    this.getRowData =
      getRowData ||
      function (col, row) {
        return row[col.field];
      };
  }
}

export default BaseCellRender;
